export const landingFeatures = (translation) => {
  return [
    {
      img: 'assets/feature2.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature2,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature2,
    },
    {
      img: 'assets/feature1.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature1,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature1,
    },
    {
      img: 'assets/feature3.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature3,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature3,
    },
    {
      img: 'assets/feature4.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature4,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature4,
    },
    {
      img: 'assets/feature5.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature5,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature5,
    },
    {
      img: 'assets/feature6.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature6,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature6,
    },
    {
      img: 'assets/feature7.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature7,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature7,
    },
    {
      img: 'assets/feature8.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature8,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature8,
    },
    {
      img: 'assets/feature9.svg',
      title: translation.home.SolutionsParagraphFeatures.Feature9,
      description: translation.home.SolutionsParagraphSubFeatures.sub_feature9,
    },
  ];
};
